import {
  Facebook,
  Instagram,
  Twitter,
  LinkedIn,
  YouTube,
} from "@mui/icons-material";
import {
  Box,
  Container,
  Unstable_Grid2,
  Typography,
  TextField,
  Button,
} from "@mui/material";
import { Link } from "gatsby";
import React from "react";

export const Footer = () => (
  <Box sx={{ background: "white", pt: 3, pb: 1, mt: 3 }}>
    <Container maxWidth="lg">
      <Unstable_Grid2 container spacing={3}>
        <Unstable_Grid2 xl={4}>
          <Typography
            variant="h5"
            noWrap
            sx={{
              // lineHeight: 1,
              mb: 2,
            }}
          >
            <Box
              component="span"
              sx={{
                backgroundImage:
                  "linear-gradient(0deg, rgb(64, 9, 3), rgb(150, 23, 7))",
                backgroundSize: "100%",
                backgroundRepeat: "repeat",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontWeight: 900,
              }}
            >
              {"ВЕСТИ".toUpperCase()}
            </Box>
            <span
              style={{
                fontWeight: 900,
                textDecoration: "none",
                color: "black",
              }}
            >
              МАК.MK
            </span>
          </Typography>
          <Typography
          // mb={3}
          >
            Независен медиум кој објавува проверени и навремени вести од Северна
            Македонија и светот, со фокус на објективно информирање.
          </Typography>

          {/* <Typography>
            <Link to="/privacy-policy">Политика за поверителност</Link>
          </Typography>
          <Typography>
            <Link to="/programen-tekst">Програмен текст</Link>
          </Typography> */}
        </Unstable_Grid2>
        <Unstable_Grid2 xl={4}>
          {/* <Typography variant="h5" fontWeight={"bold"} mb={3} color="primary">
            БИЛЕТИН
          </Typography>
          <Typography mb={3}>
            Добијте ги најважните Вестимак вести секоја утро во вашата е-пошта.
          </Typography>
          <TextField size="small" sx={{ mr: 2 }} />
          <Button variant="contained">ЗАПИШИ СЕ</Button> */}
        </Unstable_Grid2>
        <Unstable_Grid2 xl={4}>
          <Typography
            variant="h5"
            fontWeight={"bold"}
            mb={2}
            color="primary.dark"
          >
            Следи нè!
          </Typography>
          <Typography mb={3}>
            Следете нè на социјалните мрежи и помогнете во поддршката на
            независното новинарство. Вашата поддршка значи многу!
          </Typography>
          <Link to="https://www.facebook.com/vestimak.mk" target={"_blank"}>
            <Facebook fontSize="large" sx={{ mr: 3, color: "primary.dark" }} />
          </Link>
          <Link to="https://www.instagram.com/vestimakmk">
            <Instagram fontSize="large" sx={{ mr: 3, color: "primary.dark" }} />
          </Link>
          <Link to="https://x.com/vestimakmk">
            <Twitter fontSize="large" sx={{ color: "primary.dark" }} />
          </Link>
          {/* <LinkedIn color="primary" fontSize="large" sx={{ mr: 3 }} />
          <YouTube color="primary" fontSize="large" sx={{ mr: 3 }} /> */}
        </Unstable_Grid2>
      </Unstable_Grid2>
      <Typography>© 2025. Сите права запазени</Typography>
    </Container>
  </Box>
);
